document.addEventListener('DOMContentLoaded', () => {
  var mmS = window.mmS || function (k, d) { return d; }, mmF = window.mmF || function (k, d, o) { return String(d).replace(/\{(\w+)\}/g, function (x, n) { return o && o[n] != null ? o[n] : x; }); }, mmP = window.mmP || function (p) { return p; }, mmL = window.mmL || function (t) { return t; };
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('.site-nav');
  if (toggle && nav) toggle.addEventListener('click', () => { const open = nav.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', open); });
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const dataNode = picker.querySelector('[data-variant-data]');
    if (!dataNode) return;
    const variants = JSON.parse(dataNode.textContent);
    const colorButtons = Array.from(picker.querySelectorAll('[data-color-value]'));
    const sizeSelect = picker.querySelector('[data-size-select]');
    const variantInput = picker.querySelector('[data-variant-id]');
    const title = picker.querySelector('[data-product-title]');
    const price = picker.querySelector('[data-product-price]');
    const selectedColorLabel = picker.querySelector('[data-selected-color]');
    const image = picker.querySelector('[data-product-media] img');
    const addButton = picker.querySelector('[data-add-to-cart]');
    let selectedColor = picker.dataset.initialColor || variants[0]?.color;
    let selectedSize = picker.dataset.initialSize || variants[0]?.size;
    const sync = (updateUrl = true) => {
      let variant = variants.find((item) => item.color === selectedColor && item.size === selectedSize);
      if (!variant) variant = variants.find((item) => item.color === selectedColor && item.available) || variants.find((item) => item.color === selectedColor) || variants[0];
      if (!variant) return;
      selectedColor = variant.color;
      selectedSize = variant.size;
      if (variantInput) variantInput.value = variant.id;
      if (sizeSelect) {
        Array.from(sizeSelect.options).forEach((option) => { option.disabled = !variants.some((item) => item.color === selectedColor && item.size === option.value && item.available); });
        sizeSelect.value = selectedSize;
      }
      colorButtons.forEach((button) => {
        const active = button.dataset.colorValue === selectedColor;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (selectedColorLabel) selectedColorLabel.textContent = selectedColor;
      if (title) title.textContent = title.dataset.baseTitle + ' - ' + selectedColor;
      if (price) price.textContent = variant.price;
      if (image && variant.image) {
        image.removeAttribute('srcset');
        image.src = variant.image;
        image.alt = (title?.dataset.baseTitle || '') + ' - ' + selectedColor;
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? mmS('add_to_bag', 'Add to bag') : mmS('sold_out_title', 'Sold out');
      }
      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };
    colorButtons.forEach((button) => button.addEventListener('click', () => { selectedColor = button.dataset.colorValue; sync(true); }));
    if (sizeSelect) sizeSelect.addEventListener('change', () => { selectedSize = sizeSelect.value; sync(true); });
    sync(false);
  });
  document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault(); const message = form.querySelector('[data-form-message]'); const button = form.querySelector('button[type="submit"]'); button.disabled = true; message.textContent = mmS('adding', 'Adding…');
    try { const res = await fetch(mmP('/cart/add.js'),{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)}); if (!res.ok) throw new Error(); const item = await res.json(); const count = document.querySelector('[data-cart-count]'); if (count) count.textContent = Number(count.textContent || 0) + item.quantity; message.textContent = mmS('added_to_bag', 'Added to bag.'); } catch { message.textContent = mmS('add_unable', 'Unable to add this item. Please try again.'); } finally { button.disabled = false; }
  }));
});
